var PaymentCombinedStrategy = (function (_, $, PromiseUtil, PaymentStrategy) {

	var PaymentCombinedStrategy = function (strategies) {
		PaymentStrategy.apply(this, arguments);
		this._foldedMethods = this._getMethodsObject(strategies);
	};

	// Used underscore version doesn't support _.create()
	var PaymentCombinedStrategyIntermediate = function () { };
	PaymentCombinedStrategyIntermediate.prototype = PaymentStrategy.prototype;

	PaymentCombinedStrategy.prototype = _.extend(new PaymentCombinedStrategyIntermediate(), {
		constructor: PaymentCombinedStrategy,

		beforeProcess: function () {
			return this._fold(this._foldedMethods.beforeProcess, arguments);
		},

		betweenProcessAndComplete: function () {
			return this._fold(this._foldedMethods.betweenProcessAndComplete, arguments);
		},

		afterComplete: function () {
			return this._fold(this._foldedMethods.afterComplete, arguments);
		},

		afterTryComplete: function () {
			return this._fold(this._foldedMethods.afterTryComplete, arguments);
		},

		_fold: function (methods, args) {
			return _.reduce(_.rest(methods), function (memo, next) {
				return memo.pipe(next);
			}, _.first(methods).apply(this, args));
		},

		// Returns object with arrays of folded methods.
		_getMethodsObject: function (strategies) {
			return _.reduce(strategies, function (memo, next) {
				_.each(memo, function (v, k) {
					memo[k] = memo[k].concat([_.bind(next[k], next)]);
				});
				return memo;
			}, {
				beforeProcess: [],
				betweenProcessAndComplete: [],
				afterComplete: [],
				afterTryComplete: []
			});
		}
	});

	return PaymentCombinedStrategy;
})(_, $, PromiseUtil, PaymentStrategy);
